var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditResend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    className: "injected-svg",
    "data-src": "/static/media/doc-pencil-icon.1cf20499.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4799 6.23997V4.49331M11.4799 4.49331L7.98663 1M11.4799 4.49331H7.98663L7.98663 1M7.98663 1H2.16444C1.51854 1 1 1.52309 1 2.16444V12.6444C1 13.2857 1.51854 13.8088 2.16444 13.8088H5.10282M9.36485 15.4281L6.99504 15.9921L7.55906 13.6223L12.8309 8.25955C13.1811 7.90021 13.7588 7.89567 14.1136 8.255L14.7367 8.87816C15.0915 9.23295 15.087 9.81062 14.7276 10.1609L9.36485 15.4281Z",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditResend);
export default __webpack_public_path__ + "static/media/edit_resend.2befcc54867bd59e3bc6e4113a7de67e.svg";
export { ForwardRef as ReactComponent };